// strings/world.ts (M0-T06, §7.1) — world object names, lower case: used inside sentences
import type { StringBank } from '../schema/strings';

export default {
  tree: 'tree', grove: 'grove', fruitTree: 'fruit tree', rock: 'rock', stump: 'stump', shop: 'shop', museum: 'museum', well: 'well',
  windmill: 'windmill', market: 'market stall', cafe: 'café', house: 'house', mailbox: 'mailbox', board: 'news board',
  dropbox: 'drop box', bridge: 'bridge', bush: 'bush', log: 'log pile', mushrooms: 'mushrooms', barrel: 'barrel', crate: 'crate',
  wheelbarrow: 'wheelbarrow', lumber: 'lumber stack', lily: 'water lily', removeConfirm: 'Remove this {object}?',
} as const satisfies StringBank;
